/*
  <lp-slider> — thin wrapper around the globally loaded Swiper bundle (theme.liquid
  loads swiper-bundle.min.js/.css on every page). Markup contract:

  <lp-slider data-options='{"slidesPerView":1.15,"breakpoints":{"768":{"slidesPerView":3}}}'>
    <div class="swiper lp-slider__viewport">
      <div class="swiper-wrapper">
        <div class="swiper-slide">…</div>
      </div>
    </div>
    <button class="lp-slider__arrow lp-slider__arrow--prev" type="button">…</button>   (optional)
    <button class="lp-slider__arrow lp-slider__arrow--next" type="button">…</button>   (optional)
    <div class="lp-slider__dots"></div>                                                (optional)
  </lp-slider>

  Re-initialises itself whenever the element is (re)attached, which covers the theme
  editor's shopify:section:load without extra listeners.
*/
if (!customElements.get('lp-slider')) {
  customElements.define(
    'lp-slider',
    class LpSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.swiper');
        if (!this.viewport) return;
        this.whenSwiperReady(() => this.init());
      }

      disconnectedCallback() {
        this.destroy();
      }

      whenSwiperReady(cb, tries = 0) {
        if (typeof window.Swiper !== 'undefined') return cb();
        if (tries > 100) return;
        setTimeout(() => this.whenSwiperReady(cb, tries + 1), 50);
      }

      init() {
        if (this.swiper) return;
        let options = {};
        try {
          options = JSON.parse(this.dataset.options || '{}');
        } catch (e) {
          options = {};
        }
        const prev = this.querySelector('.lp-slider__arrow--prev');
        const next = this.querySelector('.lp-slider__arrow--next');
        const dots = this.querySelector('.lp-slider__dots');

        this.swiper = new window.Swiper(this.viewport, {
          slidesPerView: 1.15,
          spaceBetween: 16,
          grabCursor: true,
          watchOverflow: true,
          ...(prev && next ? { navigation: { prevEl: prev, nextEl: next } } : {}),
          ...(dots ? { pagination: { el: dots, clickable: true } } : {}),
          ...options,
        });
        this.classList.add('lp-slider--ready');
      }

      destroy() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
        this.classList.remove('lp-slider--ready');
      }
    }
  );
}
